module.exports = __webpack_public_path__ + "img/phone.fe567fed.svg";